import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { queryConfig } from '@/lib/react-query';

type Props = {};

export const ReactQueryClientProvider = ({
  children,
}: React.PropsWithChildren<Props>) => {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: queryConfig,
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
